<template>
  <div>
    <b-form>
      <b-card title="Informations Générales">
        <b-row>
          <b-col md="6" xl="3">
            <b-form-group label="Concession" label-for="concession">
              <v-select id="concession" :disabled="disabledFields.filter(item => item == 'concession').length != 0" v-model="vehicule.concession"
                        :options="$store.state.initialConfigModule.initialState.concessions" label="libelle"/>
            </b-form-group>
          </b-col>
          <b-col md="6" xl="3">
            <b-form-group label="Site *"  :class="{'is-invalid' : form_errors.site}" label-for="site">
              <v-select id="site" :disabled="disabledFields.filter(item => item == 'site').length != 0" v-model="vehicule.site" :options="sitesOptions"
                        label="libelle"/>
              <small v-if="form_errors.site" class="text-danger">{{ form_errors.site[0] }}</small>
            </b-form-group>
          </b-col>
          
          <b-col md="6" xl="3">
            <b-form-group label="Date de MEC *" label-for="date_mec">

              <cleave
                  id="date_mec"
                  v-model="vehicule.date_mec"
                  class="form-control"
                  :class="{'is-invalid' : form_errors.date_mec}"
                  :raw="false"
                  :options="cleave_options.date"
                  placeholder="JJ/MM/AAAA"
              />
              <small v-if="form_errors.date_mec" class="text-danger">{{ form_errors.date_mec[0] }}</small>
            </b-form-group>
          </b-col>
          <b-col md="6" xl="3">
            <b-form-group label="Genre *" :class="{'is-invalid' : form_errors.genre}" label-for="genre">
              <v-select id="genre" v-model="vehicule.genre"
                        :options="$store.state.initialConfigModule.initialState.genres" label="libelle"/>
              <small v-if="form_errors.genre" class="text-danger">{{ form_errors.genre[0] }}</small>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
      <b-card title="Identification du véhicule">
        <b-row>
          <b-col md="6" xl="3">
            <b-form-group label="Marque *" :class="{'is-invalid' : form_errors.marque}" label-for="marque">
              <v-select v-model="vehicule.marque" id="marque" :options="referentiel.marques" label="libelle"/>
              <small v-if="form_errors.marque" class="text-danger">{{ form_errors.marque[0] }}</small>
            </b-form-group>
          </b-col>
          <b-col md="6" xl="3">
            <b-form-group label="Modèle *" :class="{'is-invalid' : form_errors.modele}" label-for="modele">
              <v-select v-model="vehicule.modele" id="modele" :options="referentiel.modeles" label="libelle"/>
              <small v-if="form_errors.modele" class="text-danger">{{ form_errors.modele[0] }}</small>
            </b-form-group>
          </b-col>
          <b-col md="6" xl="3">
            <b-form-group label="Energie *" :class="{'is-invalid' : form_errors.energie}" label-for="energie">
              <v-select id="energie" v-model="vehicule.energie" :options="referentiel.energies" label="libelle"/>
              <small v-if="form_errors.energie" class="text-danger">{{ form_errors.energie[0] }}</small>
            </b-form-group>
          </b-col>
          <b-col md="6" xl="3">
            <b-form-group label="Type de boite *" :class="{'is-invalid' : form_errors.type_boite}"
                          label-for="type_boite">
              <v-select id="type_boite" v-model="vehicule.type_boite" :options="referentiel.type_boites"
                        label="libelle"/>
              <small v-if="form_errors.type_boite" class="text-danger">{{ form_errors.type_boite[0] }}</small>
            </b-form-group>
          </b-col>
          <b-col md="6" xl="3">
            <b-form-group label="Version *" :class="{'is-invalid' : form_errors.version}" label-for="version">
              <v-select id="version" v-model="vehicule.version" :options="referentiel.versions"
                        label="libelle"/>
              <small v-if="form_errors.version" class="text-danger">{{ form_errors.version[0] }}</small>
            </b-form-group>
          </b-col>
          <b-col md="6" xl="3">
            <b-form-group label="Puissance DIN" label-for="puissance_din">
              <b-form-input :class="{'is-invalid' : form_errors.puissance_din}" v-model="vehicule.puissance_din"
                            id="puissance_din" label="text"/>
              <small v-if="form_errors.puissance_din" class="text-danger">{{ form_errors.puissance_din[0] }}</small>
            </b-form-group>
          </b-col>
          <b-col md="6" xl="3">
            <b-form-group label="CV Fiscaux" label-for="cv_fiscaux">
              <b-form-input v-model="vehicule.cv_fiscaux" :class="{'is-invalid' : form_errors.cv_fiscaux}"
                            id="cv_fiscaux" :options="[]" label="text"/>
              <small v-if="form_errors.cv_fiscaux" class="text-danger">{{ form_errors.cv_fiscaux[0] }}</small>
            </b-form-group>
          </b-col>
          <b-col md="6" xl="3">
            <b-form-group label="Emission co2" label-for="emission_co2">
              <b-form-input v-model="vehicule.emission_co2" :class="{'is-invalid' : form_errors.emission_co2}"
                            id="emission_co2" :options="[]" label="text"/>
              <small v-if="form_errors.emission_co2" class="text-danger">{{ form_errors.cv_fiscaux[0] }}</small>
            </b-form-group>
          </b-col>
          <b-col md="6" xl="3">
            <b-form-group label="Nombre de portes" label-for="nbr_portes">
              <b-form-input v-model="vehicule.nbr_portes" :class="{'is-invalid' : form_errors.nbr_portes}"
                            id="nbr_portes" placeholder="Nombre de portes"/>
              <small v-if="form_errors.nbr_portes" class="text-danger">{{ form_errors.nbr_portes[0] }}</small>
            </b-form-group>
          </b-col>
          <b-col md="6" xl="3">
            <b-form-group label="Nombre de places" label-for="nbr_places">
              <b-form-input v-model="vehicule.nbr_places" :class="{'is-invalid' : form_errors.nbr_places}"
                            id="nbr_places" placeholder="Nombre de places"/>
              <small v-if="form_errors.nbr_places" class="text-danger">{{ form_errors.nbr_places[0] }}</small>
            </b-form-group>
          </b-col>
          <b-col md="6" xl="3">
            <b-form-group label="Carrosserie" label-for="carrosserie">
              <b-form-input v-model="vehicule.carrosserie" :class="{'is-invalid' : form_errors.carrosserie}"
                            id="carrosserie" placeholder="Carrosserie"/>
              <small v-if="form_errors.carrosserie" class="text-danger">{{ form_errors.carrosserie[0] }}</small>
            </b-form-group>
          </b-col>
          <b-col md="6" xl="3">
            <b-form-group label="-" label-for="vehicule_importation">
              <b-form-checkbox :value="true" v-model="vehicule.vehicule_importation"
                               :class="{'is-invalid' : form_errors.vehicule_importation}" class="custom-control-primary"
                               id="vehicule_importation">Véhicule d'importation
              </b-form-checkbox>
              <small v-if="form_errors.vehicule_importation"
                     class="text-danger">{{ form_errors.vehicule_importation[0] }}</small>
            </b-form-group>
          </b-col>
          <b-col md="6" xl="3">
            <b-form-group label="Peinture" label-for="peinture">
              <v-select id="peinture" v-model="vehicule.peinture"
                        :options="$store.state.initialConfigModule.initialState.peintures" label="libelle"/>
            </b-form-group>
          </b-col>
          <b-col md="6" xl="3">
            <b-form-group label="Couleur" label-for="couleur">

              <b-form-input id="couleur" v-model="vehicule.couleur"/>
            </b-form-group>
          </b-col>
          <b-col md="6" xl="3" v-if="vehicule.id">
            <b-form-group label="-" label-for="sd">
              <b-button   @click="updateEquipementVersion" :disabled="pendingUpdate" variant="primary" >   Mise a jour equipements ({{vehicule.version ? vehicule.version.id : '-'  }}) <b-spinner v-if="pendingUpdate" small label="Spinning"></b-spinner> </b-button>
            </b-form-group>
      
          </b-col>
        </b-row>
      </b-card>
      <b-card title="Informations stock">
        <b-row>
          <b-col md="6" xl="3">
            <b-form-group label="N° d'entrée ou de police" label-for="num_entree">
              <b-form-input :class="{'is-invalid' : form_errors.num_entree}" v-model="vehicule.num_entree"
                            id="num_entree" placeholder="N° d'entrée ou de police"/>
              <small v-if="form_errors.num_entree" class="text-danger">{{ form_errors.num_entree[0] }}</small>

            </b-form-group>
          </b-col>
          <b-col md="6" xl="3">
            <b-form-group label="Date d'entrée" :class="{'is-invalid' : form_errors.date_entree}"
                          label-for="date_entree">

              <cleave
                  id="date_carte_grise"
                  v-model="vehicule.date_entree"
                  class="form-control"
                  :raw="false"
                  :options="cleave_options.date"
                  placeholder="JJ/MM/AAAA"
              />
              <small v-if="form_errors.date_entree" class="text-danger">{{ form_errors.date_entree[0] }}</small>
            </b-form-group>
          </b-col>
          <b-col md="6" xl="3" v-show="!vehicule.statut_vente.hidden">
            <b-form-group label="Statut" label-for="statut_vente">
              <v-select :disabled="!$can('edition-statut-vente', 'vehicule')" id="statut_vente" v-model="vehicule.statut_vente"
                        :options="$store.state.initialConfigModule.initialState.vehicule_statuts_ventes"
                        label="libelle"/>
            </b-form-group>
          </b-col>

        </b-row>
      </b-card>
      <b-card title="Informations spécifités véhicule">
        <b-row>
          <b-col md="6" xl="3">
            <b-form-group label="Immatriculation *" label-for="immatriculation">
              <b-form-input id="immatriculation" :class="{'is-invalid' : form_errors.immatriculation}"
                            v-model="vehicule.immatriculation" placeholder="Immatriculation"/>
              <small v-if="form_errors.immatriculation" class="text-danger">{{ form_errors.immatriculation[0] }}</small>
            </b-form-group>
          </b-col>
          <b-col md="6" xl="3">
            <b-form-group label="VIN *" label-for="vin">
              <b-form-input maxlength="17" :class="{'is-invalid' : form_errors.vin}" v-model="vehicule.vin" id="vin"
                            placeholder="VIN"/>
              <small v-if="form_errors.vin" class="text-danger">{{ form_errors.vin[0] }}</small>
            </b-form-group>
          </b-col>
          <b-col md="6" xl="3">
            <b-form-group label="Date de carte grise *" label-for="date_carte_grise">
              <cleave
                  id="date_carte_grise"
                  :class="{'is-invalid' : form_errors.date_carte_grise}"
                  v-model="vehicule.date_carte_grise"
                  class="form-control"
                  :raw="false"
                  :options="cleave_options.date"
                  placeholder="JJ/MM/AAAA"
              />
              <small v-if="form_errors.date_carte_grise"
                     class="text-danger">{{ form_errors.date_carte_grise[0] }}</small>
            </b-form-group>
          </b-col>
          <b-col md="6" xl="3">
            <b-form-group label="Date du dernier contrôle technique " label-for="date_dernier_controle_technique">

              <cleave
                  id="date_dernier_controle_technique"
                  v-model="vehicule.date_dernier_controle_technique"
                  class="form-control"
                  :raw="false"
                  :options="cleave_options.date"
                  placeholder="JJ/MM/AAAA"
              />
            </b-form-group>
          </b-col>
          <b-col md="6" xl="3">
            <b-form-group label="Kilométrage *" label-for="kilometrage">
              <b-form-input type="number" :class="{'is-invalid' : form_errors.kilometrage}" v-model="vehicule.kilometrage"
                            id="kilometrage" placeholder="Kilométrage"/>
              <small v-if="form_errors.kilometrage" class="text-danger">{{ form_errors.kilometrage[0] }}</small>

            </b-form-group>
          </b-col>
          <b-col md="6" xl="3">
            <b-form-group label="-" label-for="kilometrage_garanti">

              <b-form-checkbox :value="true" v-model="vehicule.kilometrage_garanti" checked="true"
                               class="custom-control-primary"
                               name="kilometrage_garanti">Kilométrage
                garanti
              </b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col md="6" xl="3">
            <b-form-group label="-" label-for="garantie_constructeur_encours">

              <b-form-checkbox :value="true" v-model="vehicule.garantie_constructeur_encours"
                               class="custom-control-primary"
                               name="garantie_constructeur_encours">
                Garantie constructeur en cours
              </b-form-checkbox>

            </b-form-group>
          </b-col>

          <b-col md="6" xl="3">
            <b-form-group label="Garantie" label-for="garantie">
              <v-select v-model="vehicule.garantie" id="garantie"
                        :options="$store.state.initialConfigModule.initialState.vehicule_garanties" label="libelle"/>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
      <b-card title="Informations d'achat">
        <b-row>
          <b-col md="6" xl="3">
            <b-form-group label="Date d'achat" label-for="date_achat">
              <cleave
                  id="date_achat"
                  :class="{'is-invalid' :  form_errors['date_achat']}"
                  v-model="vehicule.date_achat"
                  class="form-control"
                  :raw="false"
                  :options="cleave_options.date"
                  placeholder="JJ/MM/AAAA"
              />
              <small v-if="form_errors['date_achat']" class="text-danger">{{ form_errors['date_achat'][0] }}</small>
            </b-form-group>
          </b-col>
          <b-col md="6" xl="3" v-show="false">
            <b-form-group label="Prix d'achat" label-for="prix_achat">
              <b-form-input v-model="vehicule.prix_achat" id="prix_achat"
                            placeholder="Prix d'achat"/>
            </b-form-group>
          </b-col>
          <b-col md="6" xl="3">
            <b-form-group label="Date d'entrée prévisionnelle" label-for="date_entree_previsionnelle">

              <cleave
                  id="date_entree_previsionnelle"
                  v-model="vehicule.date_entree_previsionnelle"
                  class="form-control"
                  :raw="false"
                  :options="cleave_options.date"
                  placeholder="JJ/MM/AAAA"
              />
            </b-form-group>
          </b-col>
          <b-col md="6" xl="3">

            <b-form-group label="Provenance *" :class="{'is-invalid' : form_errors['provenance']}"
                          label-for="provenance">
              <v-select id="provenance" v-model="vehicule.provenance"
                        :options="$store.state.initialConfigModule.initialState.vehicule_provenances" label="libelle"/>
              <small v-if="form_errors['provenance']" class="text-danger">{{ form_errors['provenance'][0] }}</small>
            </b-form-group>
          </b-col>

          <b-col md="6" xl="3">
            <b-form-group label="Origine *" label-for="origine" :class="{'is-invalid' : form_errors['origine']}">
              <v-select id="origine" v-model="vehicule.origine"
                        :options="$store.state.initialConfigModule.initialState.vehicule_origines" label="libelle"/>
              <small v-if="form_errors['origine']" class="text-danger">{{ form_errors['origine'][0] }}</small>
            </b-form-group>
          </b-col>

          <b-col md="6" xl="3">
            <b-form-group label="-" label-for="vehicule_premiere_main">

              <b-form-checkbox :value="true" v-model="vehicule.vehicule_premiere_main" class="custom-control-primary"
                               id="vehicule_premiere_main">Véhicule première main
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <b-col md="6" xl="3">
            <b-form-group label="-" label-for="is_financement_en_cours">

              <b-form-checkbox :value="true" v-model="vehicule.is_financement_en_cours" class="custom-control-primary"
                               id="is_financement_en_cours">Financement en cours
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <b-col md="6" xl="3">
            <b-form-group label="Propriétaire *" label-for="proprietaire" :class="{'is-invalid' : form_errors['proprietaire']}">
              <div class="d-flex custom-group-select">
                
                
                
                
                <v-select class="flex-grow-1" @search="fetchClients" id="proprietaire" v-model="vehicule.proprietaire"
                          :options="partenaires"
                          label="full_name">
                  <template slot="no-options">
                    Rechercher un client ...
                  </template>
                </v-select>
                <b-button :class="{'is-invalid' : form_errors['proprietaire']}" @click="openModalAjouterClient" style="border-radius: 0 0.358rem 0.358rem 0;"
                          variant="outline-primary">Ajouter
                </b-button>
                <b-modal
                    ref="modal_client"
                    id="modal-prevent-closing"
                    title="Ajouter client"
                    ok-title="Enregistrer"
                    cancel-title="Annuler"
                    cancel-variant="outline-secondary"
                    size="lg"
                    @ok.prevent="ajouterClientHanler"
                >
                  <client-form @submited="setClient" ref="popup_client" :show-save-button="false" />
                </b-modal>
              </div>
              <small v-if="form_errors['proprietaire']" class="text-danger">{{ form_errors['proprietaire'][0] }}</small>
            </b-form-group>
          </b-col>
          <b-col md="6" xl="3">
            <b-form-group label="Vendeur" label-for="vendeur">
              <v-select :disabled="!$can('gerer-changer-vendeur', 'stock')" @search="fetchVendeurs" id="vendeur" v-model="vehicule.vendeur" :options="vendeurs"
                        label="full_name">
                <template slot="no-options">
                  Rechercher un vendeur ...
                </template>
              </v-select>
            </b-form-group>
          </b-col>

        </b-row>
      </b-card>
      <b-card title="Informations complémentaires">
        <b-row>
          <b-col md="6" xl="3">
            <b-form-group label="-" label-for="essai_effectue">

              <b-form-checkbox :value="true" v-model="vehicule.essai_effectue" class="custom-control-primary"
                               id="essai_effectue">
                Essai effectué
              </b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col md="6" xl="3">
            <b-form-group label="Kilométrage prévu à livraison" label-for="kilometrage_prevu_livraison">
              <b-form-input v-model="vehicule.kilometrage_prevu_livraison" id="kilometrage_prevu_livraison"
                            placeholder="Kilométrage prévu à livraison"/>
            </b-form-group>
          </b-col>
          <b-col md="6" xl="3">
            <b-form-group label="N° certificat d'immatriculation " label-for="num_certificat_immatriculation">
              <b-form-input v-model="vehicule.num_certificat_immatriculation" id="num_certificat_immatriculation"
                            placeholder="N° certificat d'immatriculation"/>
            </b-form-group>
          </b-col>


        </b-row>
        <b-row>
          <b-col md="12" xl="12">
            <b-form-group label="Commentaire " label-for="commentaire">
              <b-form-textarea
                  v-model="vehicule.commentaire"
                  id="commentaire"
                  placeholder="Commentaire"
                  rows="3"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12" xl="12">
            <b-form-group label="Description Avito " label-for="description_avito" >
              <b-form-textarea
                  :class="{'is-invalid' : form_errors['description_avito']}"
                  v-model="vehicule.description_avito"
                  id="description_avito"
                  placeholder="Description Avito"
                  rows="3"
              />
              <small v-if="form_errors.description_avito" class="text-danger">{{ form_errors.description_avito[0] }}</small>
            </b-form-group>


          </b-col>
        </b-row>
      </b-card>
      <b-card no-title  v-if="($can('creer-modifier-stock', 'vehicule') && typeAjout == 'stock') || ($can('creer-modifier-reprise', 'reprise') && typeAjout == 'reprise') ">
        
        <div class="d-flex justify-content-between">
          <div class="text-left">
            <b-button :href="link_imprimer_bon_sortie" target="_blank" variant="primary">
              Imprimer bon de sortie
            </b-button>
          </div>
          <div class="text-right">
            <b-button v-if="($can('supprimer-stock', 'vehicule'))" @click="confirmArchiverVehicule" class="mr-1" variant="danger">
              Supprimer
            </b-button>
            <b-button @click="addVehicule" variant="primary">
              Enregistrer
            </b-button>
            <b-modal
                ref="modal_suppression_vehicule"
                title="Confirmation suppression"
                ok-title="Supprimer"
                cancel-title="Annuler"
                cancel-variant="outline-secondary"
                size="lg"
                @ok.prevent="supprimerVehicule"
            >
              <div class="">
                <h5>Êtes-vous sûr de vouloir supprimer ce véhicule ?</h5>
                <p>Vous ne pourrez pas revenir en arrière !</p>
                <h5>Les offres associées seront également supprimées</h5>
                <h6>Offres de reprise</h6>
                <ul>
                  <li v-for="offre_reprise in dataObjectDelete.offres_repris">
                    <a target="_blank" :href="'/list-des-offres/' + offre_reprise">{{ offre_reprise }}</a>
                  </li>
                </ul>
                <h6>Offres de ventes</h6>
                <ul class="list-style-square">
                  <li v-for="offre_vente in dataObjectDelete.offres_ventes">
                    <a target="_blank" :href="'/list-des-offres/' + offre_vente">{{ offre_vente }}</a>
                  </li>
                </ul>
              </div>
            </b-modal>
          </div>
        </div>

      </b-card>
 
    </b-form>
  </div>
</template>

<script>

import {
  BFormInput, BRow, BCol, BFormGroup
} from 'bootstrap-vue'
import ClientForm from "@/components/ClientForm";
import axios from "@/libs/axios";
import {getUserData} from "@/auth/utils";


export default {
  components: {
    ClientForm,

    BFormInput,
    BFormGroup,
    BRow,
    BCol
  },
  props: {
    typeAjout: {
      type: String,
      default: 'stock'
    },
    disabledFields: {
      type: Array,
      default: () => []
    },
    initialVehicule: {
      default: false,
    }
  },
  computed : {
    link_imprimer_bon_sortie(){
      return process.env.VUE_APP_API_URL + 'api/documents/bon-sortie-sans-client/' + this.vehicule.id ;
    },
    sitesOptions(){
      let _this = this;
      if(!_this.vehicule.concession) return  [];
      return this.$store.state.initialConfigModule.initialState.sites.filter(function(item){
        return item.concession &&  item.concession.id == _this.vehicule.concession.id;
      });
    }
  },
  methods: {
    async 'vehicule_genre'(new_val, old_val) {
      let _this = this;
      if (this.vehicule.date_mec) {
        this.referentiel.marques = await this.$store.dispatch('refModule/fetchMarques', {
          genre: _this.vehicule.genre.id,
          date_mec: _this.vehicule.date_mec,
        });
      }
    },
    async 'vehicule_date_mec'(new_val, old_val) {
      let _this = this;
      if (this.vehicule.genre.id) {
        this.referentiel.marques = await this.$store.dispatch('refModule/fetchMarques', {
          genre: _this.vehicule.genre.id,
          date_mec: _this.vehicule.date_mec,
        });
      }
    },
    async 'vehicule_marque'(new_val, old_val) {
      let _this = this;
      this.referentiel.modeles = await this.$store.dispatch('refModule/fetchModeles', {
        genre: _this.vehicule.genre.id,
        date_mec: _this.vehicule.date_mec,
        marque: new_val.id,
      });
    },
    async 'vehicule_modele'(new_val, old_val) {
      let _this = this;
      this.referentiel.energies = await this.$store.dispatch('refModule/fetchEnergie', {
        genre: _this.vehicule.genre.id,
        date_mec: _this.vehicule.date_mec,
        marque: _this.vehicule.marque.id,
        modele: new_val.id,
      });
    },
    async 'vehicule_energie'(new_val, old_val) {
      let _this = this;
      this.referentiel.type_boites = await this.$store.dispatch('refModule/fetchTypeBoite', {
        genre: _this.vehicule.genre.id,
        date_mec: _this.vehicule.date_mec,
        marque: _this.vehicule.marque.id,
        modele: _this.vehicule.modele.id,
        energie: new_val.id,
      });
    },
    async 'vehicule_type_boite'(new_val, old_val) {
      let _this = this;

      this.referentiel.versions = await this.$store.dispatch('refModule/fetchVersions', {
        genre: _this.vehicule.genre.id,
        date_mec: _this.vehicule.date_mec,
        marque: _this.vehicule.marque.id,
        modele: _this.vehicule.modele.id,
        energie: _this.vehicule.energie.id,
        type_boite: new_val.id,
      });

    },
    async 'vehicule_version'(new_val, old_val) {
      let _this = this;
      _this.vehicule.puissance_din = new_val.puissance_din;
      _this.vehicule.cv_fiscaux = new_val.cv_fiscaux;
      _this.vehicule.emission_co2 = new_val.emission_co2;
      _this.vehicule.nbr_portes = new_val.nbr_portes;
      _this.vehicule.nbr_places = new_val.nbr_places;
      _this.vehicule.carrosserie = new_val.carrosserie;
      _this.vehicule.volume_coffre = new_val.volume_coffre;
      _this.vehicule.poids_a_vide = new_val.poids_a_vide;
      _this.vehicule.ptac = new_val.ptac;
      _this.vehicule.reservoir = new_val.reservoir;

    },
    confirmArchiverVehicule(){

 
      let _this = this;
      _this.pendingUpdate = true;
      axios.post('/api/vehicules/confirm-archiver', {
        vehicule_id : this.vehicule.id
      }).then(function(response){
        console.log(response.data);
        _this.dataObjectDelete = response.data;
        _this.$refs.modal_suppression_vehicule.show();
        
        _this.pendingUpdate = false;
   
      });
    },
    supprimerVehicule(){
 
      let _this = this;
      _this.pendingUpdate = true;
      axios.post('/api/vehicules/archiver', {
        vehicule_id : this.vehicule.id
      }).then(function(response){
       let user =  getUserData();
       _this.$router.push(user.home);
       console.log(user);
      });
    },
    async addVehicule() {
      const canProceed = await this.checkExistingVinBeforeSubmit();
      if (!canProceed) {
        return;
      }

      let _this = this;
      _this.form_errors = {};
      this.$store.dispatch('gestionStockModule/addVehicule', this.vehicule).then(function (response) {
        _this.$emit('created', response.data);
      }).catch(function (error) {
        console.log(error.response.data.errors, 'sds');
        if (error.response) {
          _this.form_errors = error.response.data.errors;
        }

      })
    },
    async checkExistingVinBeforeSubmit() {
      const vin = (this.vehicule.vin || '').trim();
      if (!vin) {
        return true;
      }

      try {
        const response = await axios.get('/api/vehicules/stock/check-vin', {
          params: {
            vin,
            ignore_id: this.vehicule.id || null,
          },
        });

        const payload = response.data || {};
        if (!payload.exists) {
          this.vehicule.allow_duplicate_recreation = false;
          return true;
        }

        if (!payload.can_recreate) {
          const message = payload.is_historical
            ? 'Vous n’avez pas la permission de recréer ce véhicule existant. Demandez l’autorisation au responsable.'
            : 'Ce VIN est déjà utilisé sur un véhicule actif.';

          await this.$swal.fire({
            title: payload.is_historical ? 'Véhicule déjà existant' : 'VIN déjà utilisé',
            text: message,
            icon: 'error',
            confirmButtonText: 'Compris',
          });
          return false;
        }

        const previousVehicle = payload.vehicule || {};
        const confirmed = await this.$swal.fire({
          title: 'Véhicule déjà existant',
          html: `Ce VIN a déjà été enregistré.<br>Ancien véhicule : <a href="${previousVehicle.link || '#'}" target="_blank">#${previousVehicle.id || ''}</a><br>Statut : ${previousVehicle.statut_label || 'Inconnu'}`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Continuer',
          cancelButtonText: 'Annuler',
        });

        if (!confirmed.isConfirmed) {
          return false;
        }

        this.vehicule.allow_duplicate_recreation = true;
        return true;
      } catch (error) {
        console.error(error);
        return true;
      }
    },
    fetchClients(search, loading) {
      if (!search) {
        return false;
      }
      let _this = this;
      this.$store.dispatch('clientsModule/fetchClients', {
        'q': search
      }).then(function (response) {
        _this.partenaires = response.data;
      })

      console.log(search, loading)
    },
    fetchVendeurs(search, loading) {
      if (!search) {
        return false;
      }
      let _this = this;
      this.$store.dispatch('userModule/fetchUtilisateurs', {
        'q': search
      }).then(function (response) {
        _this.vendeurs = response.data;
      })
      console.log(search, loading)
    },
    setClient(client) {
      this.vehicule.proprietaire = {...client};
      this.$refs.modal_client.hide();
    },
    ajouterClientHanler() {
      console.log('--');
      this.$refs.popup_client.submit();
    },
    openModalAjouterClient() {
      this.vehicule.proprietaire = {};

      this.$refs.modal_client.show();
      console.log('----');
    },
    updateEquipementVersion(){
      let _this = this;
      _this.pendingUpdate = true;
      axios.get('/api/update-equipement-version/' + this.vehicule.version.id).then(function(){
        _this.pendingUpdate = false;
      });
    }
  },
  data() {
    return {
      pendingUpdate : false,
      dataObjectDelete : {},
      vehicule: {
        immatriculation: '',
        site: {},
        zone: {},
        date_mec: '',
        genre: {},
        marque: {},
        modele: {},
        energie: {},
        type_boite: {},
        version: {},
        puissance_din: '',
        cv_fiscaux: '',
        emission_co2: '',
        nbr_portes: '',
        nbr_places: '',
        carrosserie: '',
        vehicule_importation: false,
        peinture: {},
        couleur: '',
        num_entree: '',
        date_entree: '',
        statut_vente: {"id": 1, "libelle": "Estimation de reprise"},
        kilometrage_garanti: false,
        garantie_constructeur_encours: false,
        vin: '',
        date_carte_grise: '',
        date_dernier_controle_technique: '',
        kilometrage: '',
        date_achat: '',
        garantie: {},
        provenance: {},
        origine: {},
        proprietaire: {},
        vendeur: {},
        essai_effectue: false,
        kilometrage_prevu_livraison: '',
        num_certificat_immatriculation: '',
        commentaire: '',
        description_avito : '',
        allow_duplicate_recreation: false,
      },
      cleave_options: {
        date: {
          date: true,
          delimiter: '/',
          datePattern: ['d', 'm', 'Y'],
        },
      },
      partenaires: [{
        full_name : 'Rechercher un client'
      }],
      vendeurs: [],
      referentiel: {
        marques: [],
        modeles: [],
        energies: [],
        type_boites: [],
        versions: []
      },
      form_errors: {},
      sample:{ "proprietaire": { "id": 1, "nom": "DIKA", "prenom": "Ahmed", "full_name": "DIKA Ahmed", "cin": "CIN", "email": "dika.ahmed@client.com", "telephone": "0642481288", "adresse": "Adresse de test", "civilite": "Mr", "created_by": { "name": "dika.ahmed", "email": "dika.ahmed@gmail.com", "full_name": "DIKA Ahmed" } }, "statut_vente": { "id": 3, "libelle": "Stock" }, "site": { "id": 1, "libelle": "Site vita", "concession": { "id": 1, "libelle": "VITA" } }, "vendeur": { "id": 1, "full_name": "DIKA Ahmed" }, "date_mec": "02/02/2014", "genre": { "id": 1, "libelle": "Véhicule Particulier" }, "marque": { "id": 1, "libelle": "ABARTH", "created_at": "2020-10-22T09:05:04.000000Z", "updated_at": "2020-10-22T09:05:04.000000Z" }, "modele": { "id": 1, "libelle": "500", "created_at": "2020-10-22T09:05:04.000000Z", "updated_at": "2020-10-22T09:05:04.000000Z" }, "energie": { "id": 1, "libelle": "Essence", "created_at": "2020-10-22T09:05:04.000000Z", "updated_at": "2020-10-22T09:05:04.000000Z" }, "type_boite": { "id": 1, "libelle": "BVM5", "created_at": "2020-10-22T09:05:04.000000Z", "updated_at": "2020-10-22T09:05:04.000000Z", "_libelle": "Manuelle", "_id": 1, "text": "Manuelle" }, "version": { "libelle": "1.4 Turbo T-Jet 135", "puissance_din": 135, "cv_fiscaux": 8, "emission_co2": 155, "nbr_portes": 3, "nbr_places": 4, "volume_coffre": 185, "poids_a_vide": 0, "ptac": 0, "reservoir": 35, "carrosserie": "Berline", "identifiant": 1499425 }, "puissance_din": 135, "cv_fiscaux": 8, "emission_co2": 155, "nbr_portes": 3, "nbr_places": 4, "carrosserie": "Berline", "volume_coffre": 185, "poids_a_vide": 0, "ptac": 0, "reservoir": 35, "peinture": { "id": 1, "libelle": "Peinture (Standard)", "created_at": null, "updated_at": null }, "couleur": "Rouge", "num_entree": "2354", "date_entree": "19/05/2022", "immatriculation": "03/C/2868", "vin": "12345678901234567", "date_carte_grise": "19/05/2022", "date_dernier_controle_technique": "19/05/2022", "kilometrage": "32455", "kilometrage_garanti": true, "garantie_constructeur_encours": true, "garantie": { "id": 2, "libelle": "24 mois pièces et main d'oeuvre" }, "date_achat": "20/04/2022", "date_entree_previsionnelle": "07/04/2022", "provenance": { "id": 3, "libelle": "Importation" }, "origine": { "id": 3, "libelle": "Achat direct" }, "vehicule_premiere_main": true, "is_financement_en_cours": true, "essai_effectue": true, "kilometrage_prevu_livraison": "2334", "num_certificat_immatriculation": "2343546", "commentaire": "Commentaire de testt", "concession": { "id": 1, "libelle": "VITA" } }

    }
  },
  async created() {
    if (this.initialVehicule) {
      this.vehicule = this.initialVehicule;
    }
    this.$watch('vehicule.genre', this.vehicule_genre);
    this.$watch('vehicule.date_mec', this.vehicule_date_mec);
    this.$watch('vehicule.marque', this.vehicule_marque);
    this.$watch('vehicule.modele', this.vehicule_modele);
    this.$watch('vehicule.energie', this.vehicule_energie);
    this.$watch('vehicule.type_boite', this.vehicule_type_boite);
    this.$watch('vehicule.version', this.vehicule_version);
    this.$watch('vehicule.concession', function(){
      //this.vehicule.site = {};
    });


 
  }

}
</script>
